const GRID_SELECTOR = '.product-grid[data-testid="product-grid"]';
const observedGrids = new WeakSet();

const productItems = (grid) =>
  Array.from(grid.children).filter((node) => node.classList?.contains('product-grid__item'));

const renderedColumnCount = (grid) => {
  const template = window.getComputedStyle(grid).gridTemplateColumns;
  if (!template || template === 'none') return 1;

  const tracks = template.trim().split(/\s+/).filter(Boolean);
  return Math.max(1, tracks.length);
};

const updateContinuation = (grid) => {
  const continuation = grid.querySelector(':scope > [data-product-grid-continuation]');
  if (!continuation) return;

  continuation.hidden = true;
  continuation.style.display = 'none';
  continuation.style.removeProperty('grid-column');

  /* Sale has its own cross-page filtering controller. Never let the generic
     continuation tile compete with or reorder that grid. */
  if (document.querySelector('[data-sale-hub]')) return;

  if (grid.getAttribute('product-grid-view') !== 'default') return;

  const items = productItems(grid);
  if (!items.length) return;

  const columns = renderedColumnCount(grid);
  if (columns <= 1) return;

  const remainder = items.length % columns;
  if (remainder === 0) return;

  const missing = columns - remainder;
  continuation.hidden = false;
  continuation.style.display = 'flex';
  continuation.style.gridColumn = `span ${missing}`;
};

const resizeObserver = new ResizeObserver((entries) => {
  entries.forEach((entry) => updateContinuation(entry.target));
});

const observeGrid = (grid) => {
  if (observedGrids.has(grid)) {
    updateContinuation(grid);
    return;
  }

  observedGrids.add(grid);
  resizeObserver.observe(grid);

  const childObserver = new MutationObserver(() => {
    requestAnimationFrame(() => updateContinuation(grid));
  });
  childObserver.observe(grid, { childList: true });

  requestAnimationFrame(() => updateContinuation(grid));
};

const refresh = (root = document) => {
  if (root.matches?.(GRID_SELECTOR)) observeGrid(root);
  root.querySelectorAll?.(GRID_SELECTOR).forEach(observeGrid);
};

if (!window.__kurlectiveProductGridContinuationReady) {
  window.__kurlectiveProductGridContinuationReady = true;

  const pageObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) refresh(node);
      });
    });
  });

  pageObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => refresh(event.target));
  window.addEventListener('pageshow', () => refresh());
}

refresh();
